import api from "../../api";
import { isActiveStaff } from "../../utils/contractEnded";

// ── GRADE_ORDER: 동적 로드 (DB 기반) ──────────────────────────
export let GRADE_ORDER = [];

export async function loadGradeOrder() {
  const res = await api.get("users/users/");
  const raw = Array.isArray(res.data) ? res.data : (res.data.results || []);
  const gradeMap = {};
  raw.forEach(u => {
    if (u.position && u.position_rank != null) {
      gradeMap[u.position] = u.position_rank;
    }
  });
  const order = Object.entries(gradeMap)
    .sort((a, b) => a[1] - b[1])
    .map(([position]) => position);
  GRADE_ORDER.length = 0;
  GRADE_ORDER.push(...order);
  return order;
}

export function resolveStepLabel(stepKey, myGrade) {
  if (stepKey === "deputy_report") {
    const myIdx     = GRADE_ORDER.indexOf(myGrade);
    const targetIdx = GRADE_ORDER.indexOf("대리");
    return myIdx < targetIdx ? "대리 보고" : "대리 전달";
  }
  if (stepKey === "team_report") {
    const myIdx     = GRADE_ORDER.indexOf(myGrade);
    const targetIdx = GRADE_ORDER.indexOf("팀장");
    return myIdx < targetIdx ? "팀장 보고" : "팀장 전달";
  }
  return null;
}

// ── Step Options: 서버 DB 기반 ─────────────────────────────────
export let STEP_OPTIONS = [];
export let STEP_MAP     = {};

export const stepOptionApi = {
  list:    ()           => api.get("work-performance/step-options/").then(r => r.data),
  create:  (data)       => api.post("work-performance/step-options/", data).then(r => r.data),
  update:  (id, data)   => api.patch(`work-performance/step-options/${id}/`, data).then(r => r.data),
  remove:  (id)         => api.delete(`work-performance/step-options/${id}/`),
  removeAll: async ()   => {
    const list = await api.get("work-performance/step-options/").then(r => r.data);
    return Promise.all(list.map(o => api.delete(`work-performance/step-options/${o.id}/`)));
  },
  reorder: (orderedItems) =>
    Promise.all(orderedItems.map((item, idx) =>
      api.patch(`work-performance/step-options/${item.id}/`, { order: idx })
    )),
};

export async function loadStepOptions() {
  const data = await stepOptionApi.list();
  const opts = data.map(d => ({
    id:         d.id,
    key:        d.key,
    label:      d.label,
    icon:       d.icon,
    color:      d.color,
    defaultMin: d.default_min,
    folder:     d.folder,
    order:      d.order,
  }));
  STEP_OPTIONS = opts;
  STEP_MAP     = Object.fromEntries(opts.map(s => [s.key, s]));
  return opts;
}

// 하위 호환 (localStorage 코드 제거)
export const DEFAULT_STEP_OPTIONS = [];
export function getStepOptions()   { return STEP_OPTIONS; }
export function saveStepOptions()  {}
export function resetStepOptions() {}

export function getMin(step) {
  return step.minutes ?? STEP_MAP[step.step_type ?? step.key]?.defaultMin ?? 5;
}

const BASE = "work-performance/work-logs";

export const workPerformanceApi = {
  list: (params = {}) =>
    api.get(`${BASE}/`, { params }).then(r => r.data),
  detail: (id) =>
    api.get(`${BASE}/${id}/`).then(r => r.data),
  create: (data) =>
    api.post(`${BASE}/`, data).then(r => r.data),
  update: (id, data) =>
    api.patch(`${BASE}/${id}/`, data).then(r => r.data),
  remove: (id) =>
    api.delete(`${BASE}/${id}/`).then(r => r.data),
  toggleStep: (logId, stepId, isDone) =>
    api.patch(`${BASE}/${logId}/steps/${stepId}/done/`, { is_done: isDone }).then(r => r.data),
};

export const staffApi = {
  byGrade: async (grade) => {
    const res = await api.get("users/users/");
    const raw = Array.isArray(res.data) ? res.data : (res.data.results || []);
    const active = raw.filter(u => u.name && isActiveStaff(u) && !u.name.includes("테스트"));
    if (!grade) return active;
    if (grade === "동료") return active;
    return active.filter(u => u.position === grade);
  },
  colleagues: async (myGrade) => {
    const res = await api.get("users/users/");
    const raw = Array.isArray(res.data) ? res.data : (res.data.results || []);
    const active = raw.filter(u => u.name && isActiveStaff(u) && !u.name.includes("테스트"));
    const myIdx = GRADE_ORDER.indexOf(myGrade);
    if (myIdx === -1) return active;
    return active.filter(u => {
      const uIdx = GRADE_ORDER.indexOf(u.position || "");
      return uIdx !== -1 && uIdx <= myIdx;
    });
  },
};